import script from "./AppTextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTextArea.vue?vue&type=script&setup=true&lang=ts"

import "./AppTextArea.vue?vue&type=style&index=0&id=8132aa78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8132aa78"]])

export default __exports__